const blogData = {
  sectionTitle: "Latest Posts",
  rootUrl: "https://blog.gofhilman.my.id/",
  apiRootUrl: "https://blog-api-production-cd65.up.railway.app",
  archiveLabel: "See all posts",
  loadingMessage: "Loading latest posts...",
  emptyMessage: "No posts published yet. Visit the blog archive for more soon.",
  errorMessage:
    "Latest posts are temporarily unavailable. Visit the blog archive instead.",
};

export default blogData;
